import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';

@Component({
  selector: 'app-select-question',
  templateUrl: './select-question.component.html',
  styleUrls: ['./select-question.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class SelectQuestionComponent implements OnInit {
  options$ = new Observable<Options[]>();
  @Input() question: QQQuestionViewModel;
  @Input() showHeader: boolean = false;

  constructor() { }

  ngOnInit() {
    if(!this.question.editingValue)
      this.question.editingValue = '';
  }

  onChange() {
    this.question.setAnswer(this.question.editingValue, true);
  }
}

type Options = { Value: string, Label: string };

